import { useEffect, useState } from "react";
import { useSound } from "./SoundProvider";

/**
 * One-shot cinematic opener. Sequence (≈2.6s total):
 *   0ms     full-bleed black canvas
 *   80ms    terracotta scanline sweeps top → bottom (520ms)
 *   600ms   BRICK wordmark burns in, period drops with thunk SFX
 *   1700ms  vertical aperture slit blooms outward, iris-wipes to reveal page
 *   2600ms  unmounted
 *
 * Plays on every full page load (App mounts once). Reduced-motion: skipped.
 */
export function LoadFilm() {
  const [phase, setPhase] = useState<"scan" | "mark" | "iris" | "gone">("scan");
  const { playFx } = useSound();

  useEffect(() => {
    if (typeof window === "undefined") return;

    const t1 = window.setTimeout(() => setPhase("mark"), 600);
    const t2 = window.setTimeout(() => playFx("thunk"), 1080);
    const t3 = window.setTimeout(() => setPhase("iris"), 1700);
    const t4 = window.setTimeout(() => setPhase("gone"), 2600);
    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
      clearTimeout(t3);
      clearTimeout(t4);
    };
  }, [playFx]);

  if (phase === "gone") return null;
  return (
    <div className="load-film" data-phase={phase} aria-hidden="true">
      <span className="load-film__scanline" />
      <span className="load-film__wordmark">
        BRICK<span className="load-film__dot">.</span>
      </span>
      <span className="load-film__meta">◆ The Habit Edition · MMXXVI</span>
      <span className="load-film__iris" />
    </div>
  );
}

export default LoadFilm;
